import * as React from "react";
import {Component, Fragment} from "react";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import {History} from "history";
import AdminSchoolMenu from "../../AdminSchoolMenu";
import SchoolPageTitle from "../../SchoolPageTitle";
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import * as H from "history";
import SdsSubject from "../../../models/SdsSubject";
import {SchoolWorkloadConfig} from "../../../models/SchoolWorkloadConfig";
import Actions from "../../../redux/Actions";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react";
import SubjectExcludeEditor from "../onboard/SubjectExcludeEditor";
import LoadingPage from "../../LoadingPage";
import HelpBox from "./HelpBox";
import SyncSubjectsAndYearsPrompt from "../../SyncSubjectsAndYearsPrompt";
import School from "../../../models/School";

export interface ConfigureSubjectExcludesPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: History;
}

export interface ConfigureSubjectExcludesPageState {
    school?: School;
    sdsSubjects?: SdsSubject[];
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    
    saveInProgress: boolean;
}

class ConfigureSubjectExcludesPage extends Component<ConfigureSubjectExcludesPageProps & DispatchProps, ConfigureSubjectExcludesPageState> {
    
     public constructor(props: ConfigureSubjectExcludesPageProps & DispatchProps) {
        super(props);
        this.state = {
            sdsSubjects: undefined,
            schoolWorkloadConfig: undefined,
            saveInProgress: false
        }
    }

    async componentDidMount(): Promise<void>
    {
         await this.load();
    }
    
    load = async (): Promise<void> =>
    {
        
        const school = await this.props.apiService.getSchool(this.props.tenantId,this.props.schoolCode);
        const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId,this.props.schoolCode);
        const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId,this.props.schoolCode);

        this.setState({
            school,
            schoolWorkloadConfig,
            sdsSubjects
        });
    }

    private save = async (): Promise<void> =>
    {
        if(this.state.schoolWorkloadConfig === undefined)
        {
            return;
        }

        this.setState({
            saveInProgress: true
        });
        
        try
        {
            const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId,this.props.schoolCode,this.state.schoolWorkloadConfig);

            this.setState({
                schoolWorkloadConfig: savedSchoolWorkloadConfig
            });
            
            await this.props.dispatch(Actions.showMessageBar("Saved subject excludes",MessageBarType.success));
        }
        catch(e)
        {
            await this.props.dispatch(Actions.showMessageBar(`Error saving subject excludes : ${e}`,MessageBarType.error));
        }
        
        this.setState({
            saveInProgress: false
        });

    }

    async componentDidUpdate(prevProps: Readonly<ConfigureSubjectExcludesPageProps & DispatchProps>, prevState: any): Promise<void>
    {
        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            await this.load();
        }
    }

    public render(): JSX.Element
    {
         
         if(this.state.school === undefined || this.state.schoolWorkloadConfig === undefined || this.state.sdsSubjects === undefined)
         {
             return (<LoadingPage/>);
         }
         
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Subject Excludes" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}/>
                <SyncSubjectsAndYearsPrompt school={this.state.school} message={"SyncSubjectsAndYears must have completed for subjects to appear."}/>

                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <HelpBox
                        TitleText={"Subject Excludes"}
                        HelpBoxText={"Stop subject sites from being created and stop subjects from appearing in assignment analytics"}
                        Icon={"Blocked"}
                    />
                    <SubjectExcludeEditor
                        schoolWorkloadConfig={this.state.schoolWorkloadConfig}
                        sdsSubjects={this.state.sdsSubjects}
                        onChange={(updatedConfig) => 
                        {
                            this.setState({
                                schoolWorkloadConfig: updatedConfig
                            });
                        }
                    }/>
                    
                    <div className={"flex-row flex--justify-content-center"}>
                        <PrimaryButton onClick={this.save} disabled={this.state.saveInProgress} text={`Save Excludes`} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): ConfigureSubjectExcludesPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(ConfigureSubjectExcludesPage);